module.exports = __webpack_public_path__ + "static/media/fruit-candy.4f2335cf.jpeg";